<template>
  <div id="app-body" class="app-body" ref="body">
    <sidebar-left></sidebar-left>
    <transition name="view" mode="out-in">
        <router-view></router-view>
    </transition>
    <sidebar-right></sidebar-right>
  </div>
</template>

<script>
import SidebarLeft from "./SidebarLeft.vue";
import SidebarRight from "./SidebarRight.vue";

export default {
  data() {
    return {};
  },
  components: {
    "sidebar-left": SidebarLeft,
    "sidebar-right": SidebarRight
  }
};
</script>

<style lang=scss>
@import "~styles/_vars.scss";

/* GENERAL STYLES */

.body_box {
  margin-bottom: 2rem;
}

.body_text-plain {
  font-size: $text-plain-desktop;
  text-align: justify;

  @media screen and (max-width: $desktop-medium) {
    font-size: $text-plain-tablet;
  }

  @media screen and (max-width: $mobile) {
    font-size: $text-plain-mobile;
    text-align: left;
  }
}

.last {
  margin-bottom: 1rem;
}

.link {
  color: $dark;
  border-bottom: 1px solid currentColor;
  cursor: pointer;

  &:hover {
    color: lighten($main, 10);
  }
}

.body_image-postcard {
  margin-bottom: 5rem;
  width: 100%;
}

.body_image-hero {
  width: 100%;
}



/* CONTENT STYLES */

.content_title-main {
  margin: 1.5rem 0;
  color: $main;
  font-size: $text-title-desktop;
  text-transform: uppercase;
  border-bottom: 2px solid currentColor;

  @media screen and (max-width: $desktop-medium) {
    font-size: $text-title-tablet;
  }

  @media screen and (max-width: $mobile) {
    font-size: $text-title-mobile;
  }

  &:first-child {
    margin: 0 0 1.5rem;
  }

  &.hidden {
    margin: 0;
    visibility: hidden;
    border: none;

    @media screen and (max-width: $desktop-small) {
      display: none;
    }
  }
}

.content_title-article {
  margin: 0 0 1.5rem;
  color: $dark;
  font-weight: bold;
  font-size: $text-title-desktop;

  @media screen and (max-width: $desktop-medium) {
    font-size: $text-title-tablet;
  }

  @media screen and (max-width: $mobile) {
    font-size: $text-title-mobile;
  }
}

.content_article_date {
  padding-top: 1.5rem;
}

.content_article_link {
  color: inherit;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: border .15s;

  &:hover {
    border-bottom: 2px solid $dark;
  }
}

.content_article_image {
  cursor: pointer;
  width: 20vw;

  @media screen and (max-width: $desktop-medium) {
    width: 30vw;
  }

  @media screen and (max-width: $mobile) {
    width: 60vw;
  }

  &.wide {
    width: 30vw;

    @media screen and (max-width: $desktop-medium) {
      width: 45vw;
    }

    @media screen and (max-width: $mobile) {
      width: 100%;
    }
  }

  &.medium {
    width: 36vw;

    @media screen and (max-width: $desktop-medium) {
      width: 54vw;
    }

    @media screen and (max-width: $mobile) {
      width: 100%;
    }
  }
}

.content_article_snippet {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid $dark;
  transition: all .35s;
}

.content_article:last-child .content_article_snippet{
  border-bottom: 1px solid transparent;

}

.content_search {
  padding: 0.45rem 0.75rem;
  width: 100%;
  border: 1px solid $dark;
  border-radius: 10px;
  font-size: $text-plain-desktop;
  background-color: rgba(#fff, 0.4);
  box-shadow: 1px 2px 5px rgba(#333, 0.3);
  transition: all .35s;

  @media screen and (max-width: $desktop-medium) {
    font-size: $text-plain-tablet;
  }

  @media screen and (max-width: $mobile) {
    font-size: $text-plain-mobile;
  }

  &:focus {
    border: 1px solid black;
    outline: none;
    background-color: rgba(#f3f3f3, 1);
  }

  &+ .body_text-plain {
    margin-top: 1.5rem;
  }
}

/* single article */

.article_date {
  color: $grey;
}

.article_image-container {
  text-align: left;
}

.article_image {
  width: 60%;
  margin-bottom: 1rem;

  @media screen and (max-width: $desktop-medium) {
    width: 65%;
  }

  @media screen and (max-width: $mobile) {
    width: 70%;
  }

  &.wide {
    width: 100%;
  }

  &.medium {
    width: 100%;
  }
}

/* homepage articles preview */
.homepage-blog_wrapper {
  margin-bottom: 2rem;
}

.homepage-blog_article {
  margin-bottom: 1rem;
  padding-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid $dark;
  transition: all .35s;

  @media screen and (max-width: $mobile) {
    flex-direction: column;
  }
}

.homepage-blog_article:last-child {
  border-bottom: 1px solid transparent;
}

.homepage-blog_link {
  flex-shrink: 0;
  display: block;
  cursor: pointer;

  @media screen and (max-width: $mobile) {
    display: none;
  }
}

.homepage-blog_image {
  margin-bottom: 0;
  margin-right: 1.5rem;
  width: 9rem;
  height: auto;

  &.wide {
    width: 12rem;
  }

  &.medium {
    width: 12rem;
  }
}

.homepage-blog_news-link {
  display: inline-block;
  color: inherit;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: border .15s;

  &:hover {
    border-bottom: 2px solid $dark;
  }
}



/* SIDEBAR STYLES */

.sidebar_title-main {
  margin: 1.5rem 0;
  color: $main;
  font-size: $text-title-desktop;
  text-transform: uppercase;
  border-bottom: 2px solid lighten($main, 0);

  @media screen and (max-width: $desktop-medium) {
    font-size: $text-title-tablet;
  }

  @media screen and (max-width: $mobile) {
    font-size: $text-title-mobile;
  }

  &:first-child {
    margin: 0 0 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Body.vue